<div class="sk-page" [class.sk-page--with-list]="listPanel" aria-busy="true" aria-live="polite">
  <span class="sr-only">{{ 'common.loading' | translate }}</span>

  @if (listPanel) {
    <aside class="sk-list" data-testid="skeleton-list-panel" aria-hidden="true">
      @for (row of eight; track row) {
        <div class="sk-list__row">
          <app-skeleton variant="circle" size="40px" />
          <div class="sk-list__text">
            <app-skeleton width="70%" height="13px" />
            <app-skeleton width="45%" height="11px" />
          </div>
        </div>
      }
    </aside>
  }

  <div class="sk-main">
    <!-- The header shell. Every route in this app renders app-layout-header, so
         these boxes are the one part of a not-yet-loaded page whose geometry is
         genuinely known. Dimensions mirror layout-header.component.scss. -->
    <div class="sk-header" data-testid="skeleton-header" aria-hidden="true">
      <div class="sk-header__title-section">
        <app-skeleton
          class="sk-header__icon"
          data-testid="skeleton-header-icon"
          variant="block"
          width="44px"
          height="44px"
          radius="10px"
        />
        <div class="sk-header__text">
          <app-skeleton data-testid="skeleton-header-title" width="220px" height="17px" />
          <app-skeleton class="sk-header__subtitle" width="120px" height="14px" radius="9999px" />
        </div>
      </div>
      <div class="sk-header__actions">
        <app-skeleton variant="block" width="120px" height="36px" radius="6px" />
        <app-skeleton variant="block" width="120px" height="36px" radius="6px" />
      </div>
    </div>

    <div class="sk-body" aria-hidden="true">
      @switch (archetype) {
        @case ('cards') {
          <div class="sk-cards" data-testid="skeleton-body-cards">
            @for (card of six; track card) {
              <div class="sk-card">
                <app-skeleton width="60%" height="14px" />
                <app-skeleton class="sk-card__meta" width="40%" height="12px" />
                <app-skeleton variant="block" height="72px" />
                <div class="sk-card__footer">
                  <app-skeleton width="64px" height="12px" />
                  <app-skeleton width="48px" height="12px" />
                </div>
              </div>
            }
          </div>
        }
        @case ('dashboard') {
          <div class="sk-dashboard" data-testid="skeleton-body-dashboard">
            <div class="sk-dashboard__stats">
              @for (stat of four; track stat) {
                <div class="sk-stat">
                  <app-skeleton width="50%" height="12px" />
                  <app-skeleton class="sk-stat__value" width="72px" height="28px" />
                  <app-skeleton width="40%" height="11px" />
                </div>
              }
            </div>
            <div class="sk-dashboard__charts">
              @for (chart of two; track chart) {
                <div class="sk-chart">
                  <app-skeleton width="140px" height="14px" />
                  <app-skeleton class="sk-chart__plot" variant="block" height="220px" />
                </div>
              }
            </div>
          </div>
        }
        @case ('form') {
          <div class="sk-form" data-testid="skeleton-body-form">
            @for (field of six; track field) {
              <div class="sk-field">
                <app-skeleton width="140px" height="12px" />
                <app-skeleton class="sk-field__input" variant="block" height="44px" radius="6px" />
              </div>
            }
            <div class="sk-form__actions">
              <app-skeleton variant="block" width="104px" height="40px" radius="6px" />
              <app-skeleton variant="block" width="104px" height="40px" radius="6px" />
            </div>
          </div>
        }
        @case ('detail') {
          <div class="sk-detail" data-testid="skeleton-body-detail">
            <app-skeleton class="sk-detail__banner" variant="block" height="96px" />
            <div class="sk-detail__columns">
              @for (column of two; track column) {
                <div class="sk-detail__column">
                  <app-skeleton width="160px" height="14px" />
                  <app-skeleton variant="text" [lines]="4" />
                  <app-skeleton width="180px" height="14px" />
                  <app-skeleton variant="text" [lines]="3" />
                </div>
              }
            </div>
          </div>
        }
        @default {
          <div class="sk-table" data-testid="skeleton-body-table">
            <div class="sk-table__head">
              @for (column of five; track column) {
                <app-skeleton class="sk-table__cell" width="70%" height="11px" />
              }
            </div>
            @for (row of eight; track row) {
              <div class="sk-table__row">
                @for (column of five; track column) {
                  <app-skeleton class="sk-table__cell" width="80%" height="12px" />
                }
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
</div>
